// extracted by mini-css-extract-plugin
export default {"small_screen_disclaimer":"PreviewSection-module_small_screen_disclaimer___iyPn","desktop_configurator_container":"PreviewSection-module_desktop_configurator_container___SA8K"};